/**
 * AI Recruit - Application Entry Point
 * Vite + React + TypeScript + Tailwind CSS
 * 
 * NO MANUAL RULES - NO FALLBACKS - PURE AI INTELLIGENCE
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Error boundary for development
if (import.meta.env.DEV) {
  // Only in development
  const originalError = console.error
  console.error = (...args) => {
    if (typeof args[0] === 'string' && args[0].includes('Warning: React does not recognize')) {
      return
    }
    originalError(...args)
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
)